var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { AuthContext } from "../auth";
var initialState = {
    loadingPermissions: false,
    permissions: [],
    hasPermission: function (permissionCode) { return false; },
};
export var UserPermissionContext = React.createContext(initialState);
var PERMISSION_MOVE_TICKET = process.env.PERMISSION_MOVE_TICKET;
var PERMISSION_CANCEL_TICKET = process.env.PERMISSION_CANCEL_TICKET;
var PERMISSION_GENERATE_SUPERLOGICA = process.env.PERMISSION_GENERATE_SUPERLOGICA;
var PERMISSION_READ_CONTRACT = process.env.PERMISSION_READ_CONTRACT;
export var UserPermissionProvider = function (_a) {
    var children = _a.children, getUserPermissions = _a.getUserPermissions;
    var token = useContext(AuthContext).token;
    var _b = useState(initialState), permissionState = _b[0], setPermissionState = _b[1];
    var _c = useState(false), canMoveTicket = _c[0], setCanMoveTicket = _c[1];
    var _d = useState(false), canCancelTicket = _d[0], setCanCancelTicket = _d[1];
    var _e = useState(false), canReadContracts = _e[0], setReadContracts = _e[1];
    var _f = useState(false), canGenerateSuperlogica = _f[0], setGenerateSuperlogica = _f[1];
    var _g = useState(false), canShowSettings = _g[0], setShowSettings = _g[1];
    useEffect(function () {
        if (!!permissionState.permissions.length) {
            setCanMoveTicket(hasPermission(PERMISSION_MOVE_TICKET));
            setCanCancelTicket(hasPermission(PERMISSION_CANCEL_TICKET));
            setReadContracts(hasPermission(PERMISSION_READ_CONTRACT));
            setGenerateSuperlogica(hasPermission(PERMISSION_GENERATE_SUPERLOGICA));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionState.permissions]);
    useEffect(function () {
        setShowSettings(canMoveTicket && canCancelTicket);
    }, [canCancelTicket, canMoveTicket]);
    useLayoutEffect(function () {
        if (!token)
            return;
        setPermissionState(function (state) { return (__assign(__assign({}, state), { loadingPermissions: true })); });
        getUserPermissions
            .call()
            .then(function (permissions) {
            setPermissionState(function (state) { return (__assign(__assign({}, state), { loadingPermissions: false, permissions: permissions })); });
        })
            .catch(function () { return null; });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    var hasPermission = function (permissionCode) {
        return !!permissionState.permissions.find(function (_a) {
            var cod = _a.cod;
            return permissionCode === cod;
        });
    };
    return (React.createElement(UserPermissionContext.Provider, { value: __assign(__assign({}, permissionState), { hasPermission: hasPermission, canShowSettings: canShowSettings, canGenerateSuperlogica: canGenerateSuperlogica, canReadContracts: canReadContracts }) }, children));
};
